import React, { FC, useMemo } from 'react'
import Autocomplete, { AutocompleteChangeDetails, AutocompleteChangeReason } from '@material-ui/lab/Autocomplete/Autocomplete'
import { Value } from '@material-ui/lab'
import { useStates } from 'hooks/useStates'
import { IState } from 'typescript/interfaces/companies'
import { useSelectComponentStyle } from 'UI/Select'
import { useMultipleAutocompleteStyles } from 'components/RolesAutoComplete'
import cn from 'classnames'
import { Box, Chip } from '@material-ui/core'
import TextField from '@material-ui/core/TextField/TextField'
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as CircleArrowIcon } from 'assets/svg/CircleArrowBottomIcon.svg'
import { ReactComponent as CircleCloseIcon } from 'assets/svg/CircleCloseIcon.svg'

interface IAutoCompleteProps{
    stateId?: number | number[],
    onChange?: (
        event: React.ChangeEvent<{}>,
        value: Value<any, any, any, any>,
        reason: AutocompleteChangeReason,
        details?: AutocompleteChangeDetails<any>,
    ) => void,
    label?: string,
    smoothLeft?: boolean
    smoothRight?: boolean
    multiple?: boolean
    className?: string
}

const StateAutoComplete: FC<IAutoCompleteProps> = ({
    stateId,
    onChange,
    label = 'State',
    smoothLeft,
    smoothRight,
    className,
    multiple,
}) => {

    const { data: dataStates, isLoading: isLoadingStates } = useStates()  
    const arrayStates = useMemo(() => {
        return dataStates?.data ? dataStates.data : []
    }, [dataStates])

    const selectedOptionState = useMemo(() => {
         if (arrayStates.length > 0) {
           const findCompany = arrayStates.find((c) => c.id === stateId) || null
           return findCompany
         }
         return null
    }, [arrayStates, stateId])
    const selecetedMultipleOptionsState = useMemo(() => {
        if (Array.isArray(stateId) && arrayStates.length > 0) {
            return arrayStates.filter((c) => stateId.includes(c.id))
        }
        return []
    }, [arrayStates, stateId])

    const classes = useSelectComponentStyle()
    const mClasses = useMultipleAutocompleteStyles()

     return (
    <Autocomplete
      multiple={Boolean(multiple)}
      value={multiple ? selecetedMultipleOptionsState : selectedOptionState}
      loading={isLoadingStates}
      options={arrayStates}
      getOptionLabel={(option: IState) => {
        return option.name
      }}
      getOptionSelected={(option: IState, value) => {
        if (value && value.id) return option.id === value.id
        return false
      }}
      renderTags={(tagValue, getTagProps) => {
        return tagValue.map((option: IState, index) => <Chip label={option.name} {...getTagProps({ index })} />)
      }}
      classes={{ inputRoot: cn(mClasses.inputRoot, multiple), root: className }}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          className={cn({ [classes.disabledFormControlLeftBorder]: smoothLeft }, { [classes.disabledFormControlRightBorder]: smoothRight })}
          InputProps={{
            ...params.InputProps,
            ref: params.InputProps.ref,
            endAdornment: (
              <>
                {isLoadingStates ? <CircularProgress color="primary" size={20} /> : null}
                {selectedOptionState && (
                  <Box mr="0.25rem" display="flex" alignItems="center" justifyContent="center" style={{ cursor: 'pointer' }}>
                    <SvgIcon
                      fontSize="inherit"
                      viewBox="0 0 20 20"
                      component={CircleCloseIcon}
                      onClick={(e: any) => {
                        onChange!(e, undefined, 'clear')
                      }}
                    />
                  </Box>
                )}
                <SvgIcon fontSize="inherit" viewBox="0 0 20 20" component={CircleArrowIcon} />
              </>
            ),
          }}
          variant="outlined"
        />
      )}
    />
  )
}

export default StateAutoComplete